import React from 'react';
import { Users, Check, Loader2, MessageCircle } from 'lucide-react';
import { cn } from "@/lib/utils/cn";

export interface WhatsappGroup {
  id: string;
  displayName?: string | null;
  whatsappChatId: string;
}

interface WhatsappGroupSelectorProps {
  groups: WhatsappGroup[];
  isLoading: boolean;
  selectedGroupId: string | null;
  onSelectGroup: (id: string | null) => void;
}

export const WhatsappGroupSelector: React.FC<WhatsappGroupSelectorProps> = ({
  groups,
  isLoading,
  selectedGroupId,
  onSelectGroup,
}) => {
  return (
    <div className="space-y-3 animate-in fade-in slide-in-from-top-4 duration-500 ease-out">
      <label className="text-sm font-medium text-gray-700">WhatsApp-Gruppe</label>
      <div className="space-y-2">
        {isLoading ? (
           <div className="flex items-center justify-center py-4 bg-gray-50 rounded-xl">
              <Loader2 className="h-5 w-5 text-gray-400 animate-spin" />
           </div>
        ) : groups.length === 0 ? (
           <div className="text-center py-4 bg-gray-50 rounded-xl border border-dashed border-gray-200">
              <p className="text-sm text-gray-500">Keine Gruppen gefunden</p>
           </div>
        ) : (
          groups.map(group => {
            const isActive = selectedGroupId === group.id;
             
             return (
              <button
                key={group.id}
                type="button"
                onClick={() => onSelectGroup(isActive ? null : group.id)}
                className={cn(
                  "w-full flex items-center justify-between p-3 rounded-xl border transition-all",
                  isActive 
                    ? "border-green-500 bg-green-50 ring-1 ring-green-500" 
                    : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                )}
              >
                <div className="flex items-center gap-3 min-w-0">
                  <div className={cn(
                    "h-8 w-8 rounded-full flex-shrink-0 flex items-center justify-center",
                    isActive ? "bg-green-200 text-green-700" : "bg-gray-100 text-gray-500"
                  )}>
                    <Users className="h-4 w-4" />
                  </div>
                  <div className="flex flex-col items-start min-w-0">
                    <span className={cn("text-sm font-medium truncate max-w-[200px] text-left", isActive ? "text-green-900" : "text-gray-900")}>
                      {group.displayName || 'WhatsApp-Gruppe'}
                    </span>
                    <div className="flex items-center gap-1.5 mt-0.5">
                       <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-green-100 text-green-700">
                         <MessageCircle className="h-3 w-3" />
                         <span className="truncate max-w-[140px]">{group.displayName ? 'Verbunden' : group.whatsappChatId}</span>
                       </span>
                    </div>
                  </div>
                </div>
                {isActive && <Check className="h-4 w-4 text-green-600 flex-shrink-0" />}
              </button>
             );
          })
        )}
      </div>
    </div>
  );
};
